module.exports = __webpack_public_path__ + "static/media/TS-LINE.b4b9fa39.svg";